export const NoxusEventType = {
  // 邮件提醒 - invoke
  MailTips: 'mail-tips',
  // 获取配置信息 - invoke
  GetSetting: 'get-settings',
  // 邮件打印 - invoke
  MailPrint: 'mail-print',
  // 邮件导入
  ExportMail: '@ipcMainOn/export-mail',
  //导出邮件任务列表
  ExportMailList: '@ipcMainOn/export-mail/task-list',
  //导出邮件任务详情
  ExportMailDetail: '@ipcMainOn/export-mail/task-detail',
  //导出邮件任务重新下载
  ExportMailTaskReboot: '@ipcMainOn/export-mail/task-reboot',
  //导出邮件任务取消
  ExportMailTaskCancel: '@ipcMainOn/export-mail/task-cancel',
  // 更新未读数 - invoke
  UpdateUnread: 'read-mail',

  // 刷新邮件列表（重新请求邮件列表接口） - on
  RefreshMails: 'refresh-mails',

  // 更新邮件列表 （根据mail_id增量式更新）- on
  UpdateMails: 'update-mails',

  // 刷新用户绑定邮箱 - on
  RefreshUserMails: 'refresh-user-mails',

  // 刷新邮件模块文件夹列表 - on
  RefreshMailFolders: 'refresh-mail-folders',

  // 刷新邮件模块标签列表 - on
  RefreshMailTags: 'refresh-mail-tags',

  // 刷新邮件详情 - on
  RefreshMailDetail: 'refresh-mail-detail',

  // 刷新写邮件时签名列表 - on
  RefreshMailSigns: 'refresh-mail-signs',

  // 关闭新建的窗口 - invoke
  CloseWindow: 'close-win',

  // 桌面的准备关闭当前窗口 - on
  ReadyCloseWindow: 'ready-close-win',

  // 跳转到读取sessionStorage的页面时调用
  SessionStorage: 'use-sessionStorage',

  //成功发送群发单显
  ExposeMail: 'expose-mail',

  //快捷键列表
  ShortcutList: 'shortcut-list',

  //传递绑定token
  mailRendererIpc: '@ipcMainHandle/mail-renderer-ipc',

  //接收绑定tonken
  mailRendererIpcSend: '@ipcRendererEvent/mail-renderer-ipc-send',

  //邮件列表同步进度
  mailSyncProgress: '@ipcMainHandle/sync_progress',

  //首次绑定邮箱拉取用户数据并初始化
  mailRelaunch: '@ipcMainHandle/relaunch',

  // 下面为命令 监听noxus的快捷键操作
  Shortcut: {
    // 邮件编辑
    Draft: 'shortcut-cmd-draft', // 存草稿
    Send: 'shortcut-cmd-send', // 发送邮件
    // 邮件列表&详情
    CheckAll: 'shortcut-cmd-check-all', // 全选
    Reply: 'shortcut-cmd-reply', // 回复
    ReplyAll: 'shortcut-cmd-reply-all', // 回复全部
    Forward: 'shortcut-cmd-forward', // 转发
    MarkUnread: 'shortcut-cmd-mark-unread', // 标记未读,
    Pin: 'shortcut-cmd-pin', //打钉/取消打钉
    Delete: 'shortcut-cmd-delete', // 删除
    Move: 'shortcut-cmd-move', // 移动所有邮件
    MarkSpam: 'shortcut-cmd-mark-spam', // 标记垃圾邮件
  },

  AttachContext: 'attach-context',

  NoxusMessage: 'noxus-message',
}

// 宿主环境是桌面端
export const isInNoxus = !!window.NoxusJSBridge

// 宿主环境是桌面端 执行NoxusJSBridge逻辑
export const noxusInvoke = (type, param) => {
  if (!isInNoxus) {
    return
  }

  try {
    return window.NoxusJSBridge?.invoke?.(type, param)
    // eslint-disable-next-line no-empty
  } catch (err) {}
}

export const noxusOn = (type, callback) => {
  if (!isInNoxus) {
    return
  }

  try {
    window.NoxusJSBridge?.on?.(type, callback)
    // eslint-disable-next-line no-empty
  } catch (err) {}
}

export const noxusOff = type => {
  if (!isInNoxus) {
    return
  }

  try {
    window.NoxusJSBridge?.off?.(type)
    // eslint-disable-next-line no-empty
  } catch (err) {}
}

export const noxusEmit = (type, params) => {
  if (!isInNoxus) {
    return
  }

  try {
    window.NoxusJSBridge?.emit?.(type, params)
    // eslint-disable-next-line no-empty
  } catch (err) {}
}
